import { useState } from "react"
import { X } from "lucide-react"
import { supabase } from "../../supabaseClient"

interface Props {
  open: boolean
  onClose: () => void
  jobId: string | null
}

export default function NewSessionModal({ open, onClose, jobId }: Props) {
  const [customTime, setCustomTime] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleClockInAtTime = async () => {
    if (!jobId || !customTime) return
    setLoading(true); setError(null)
    const { error } = await supabase.rpc("tt_check_in_at_time", {
      job_id: jobId, custom_time: customTime,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
    if (error) { setError(error.message); setLoading(false); return }
    setLoading(false); setCustomTime(""); onClose()
  }

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      <div className="bg-white dark:bg-neutral-900 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 w-full max-w-sm shadow-xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-black dark:text-white">Clock-in at specific time</h3>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-neutral-800 transition">
            <X className="h-4 w-4 text-gray-500" />
          </button>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">Select the exact date and time when the session started.</p>

        <input
          type="datetime-local"
          value={customTime}
          onChange={e => setCustomTime(e.target.value)}
          className="w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-neutral-800 px-4 py-2.5 text-sm text-black dark:text-white focus:outline-none focus:border-[#2563EB] transition mb-4"
        />

        {error && <div className="text-xs text-red-600 dark:text-red-400 mb-3">{error}</div>}

        <div className="flex gap-2">
          <button onClick={onClose} className="flex-1 border border-gray-200 dark:border-gray-700 rounded-xl py-2.5 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-neutral-800 transition">
            Cancel
          </button>
          <button
            onClick={handleClockInAtTime}
            disabled={loading || !customTime}
            className="flex-1 bg-[#2563EB] text-white rounded-xl py-2.5 text-sm font-medium hover:bg-[#1d4ed8] transition disabled:opacity-40"
          >
            {loading ? "Saving…" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  )
}
